import { render } from "./OmotenashiSelection2024.vue?vue&type=template&id=7b5060cb&scoped=true"
import script from "./OmotenashiSelection2024.vue?vue&type=script&lang=js"
export * from "./OmotenashiSelection2024.vue?vue&type=script&lang=js"

import "./OmotenashiSelection2024.vue?vue&type=style&index=0&id=7b5060cb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b5060cb"

export default script